import moment from 'moment'

const hyperion = {
  computed: {
    dateRanges() {
      return {
        'Today': [this.moment(), this.moment()],
        'Yesterday': [this.moment().subtract(1, 'd'), this.moment().subtract(1, 'd')],
        'This Week': [this.moment().startOf('week'), this.moment().endOf('week')],
        'Last Week': [this.moment().subtract(1, 'w').startOf('week'), this.moment().subtract(1, 'w').endOf('week')],
        'This Month': [this.moment().startOf('month'), this.moment().endOf('month')],
        'Last Month': [this.moment().subtract(1, 'months').startOf('month'), this.moment().subtract(1, 'months').endOf('month')]
      }
    },
  },
  methods: {
    moment,
		isEmpty(value) {
    	return value === null || value === '' || typeof value  === 'undefined' || value === 0
		},
    numbering(index, pagination) {
      return (pagination.per_page * (pagination.current_page - 1)) + index + 1
    },
    pushState(state) {
      history.pushState(null, document.title, location.origin + location.pathname + "?" + this.$qs.stringify(state, {encode: false}))
    },
    isAuthenticated() {
      return this.$hyperion.is_authenticated
    },
    user() {
      return this.$hyperion.user
    },
    routes() {
      return this.$hyperion.routes
    },
    getRoute() {
      return this.$hyperion.current_route
    },
    route(name) {
      return _.find(this.routes(), (o, k) => k === name)
    },
    routeUri(name, replacer = {}, isPath = false) {
      let path = isPath ? name : '/' + (this.route(name) ? this.route(name).uri : window.location.pathname)
      return path.replace(/{([a-z0-9_]+)}/gi, (match, key) => replacer[key])
    },
    copy(value, message = null) {
      this.$clipboard(value)

      this.$message.success((message === null) ? '"' + value + '" has been copied to your clipboard.' : message)
    },
    currency(number, decimal = 2) {
      return new Intl.NumberFormat('id-ID', {style: "currency", currency: "IDR", minimumFractionDigits: decimal}).format(number)
    },
    number(number) {
      return new Intl.NumberFormat('id-ID').format(number)
    },
    getDefaultPagination() {
      return {
        current_page: 1,
        data: [],
        first_page_url: '',
        from: 1,
        last_page: 1,
        last_page_url: '',
        next_page_url: null,
        path: '',
        per_page: 15,
        prev_page_url: null,
        to: 1,
        total: 0
      }
    },
    handleXhrError(error) {
      this.$notification.error({
        message: (error.response.data.code) ? error.response.data.code : "UNKNOWN",
        description: (error.response.data.data[0]) ? error.response.data.data[0] : (error.response.data.message) ? error.response.data.message : ""
      });
    },
		filterNumeric(e) {
			const { value } = e.target
			const reg = /^-?[0-9]*(\.[0-9]*)?$/
			if ((!isNaN(value) && reg.test(value)) || value === '' || value === '-') {
				return value
			}
		},
  }
}

export default hyperion
